// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"a747f611","133":"f31a1e1c","350":"56e60610","556":"7eaf5f54","560":"4a6a339d","598":"7dde424f","634":"0bead0cc","727":"94739a11","749":"d95a0dc7"}[chunkId] + ".chunk.js";
};